(() => {
  const root = window.Shopify?.routes?.root || '/';
  const currency = window.Shopify?.currency?.active || 'USD';
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100);
  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const overlay = document.querySelector('[data-pf-page-overlay]');
  const cartDrawer = document.querySelector('[data-pf-cart-drawer]');
  const searchDrawer = document.querySelector('[data-pf-search-drawer]');
  const cartContent = document.querySelector('[data-pf-cart-content]');
  const toast = document.querySelector('[data-pf-toast]');
  let toastTimer;

  const showToast = (message) => {
    if (!toast) return;
    toast.querySelector('b').textContent = message;
    toast.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-open'), 2600);
  };
  const closeDrawers = () => {
    [cartDrawer, searchDrawer].forEach((drawer) => { drawer?.classList.remove('is-open'); drawer?.setAttribute('aria-hidden', 'true'); });
    overlay?.classList.remove('is-open');
    document.documentElement.classList.remove('pf-shell-open');
  };
  const openDrawer = (drawer) => {
    closeDrawers();
    drawer?.classList.add('is-open');
    drawer?.setAttribute('aria-hidden', 'false');
    overlay?.classList.add('is-open');
    document.documentElement.classList.add('pf-shell-open');
  };

   /* ── Cart drawer (reference-style layout) ── */
  const FREE_SHIP_MIN = 4000; // cents. Free-shipping threshold ($40)
  const POINTS_PER_DOLLAR = 1; // Flock Club rate: $1 = 1 point
  const SHIPPING_INFO = 'Free standard shipping on orders $40+. Taxes calculated at checkout.'; // edit to match your real shipping info
  const BEST_SELLERS_COLLECTION = ''; // optional: collection handle, e.g. 'best-sellers'. Empty = Shopify related products
  const toCents = (value) => { const s = String(value); return s.includes('.') ? Math.round(parseFloat(s) * 100) : parseInt(s, 10); };
  let cartRenderId = 0;

  const changeLine = async (key, quantity, controls) => {
    controls.forEach((control) => { control.disabled = true; });
    try {
      const response = await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      if (!response.ok) throw new Error('Cart update failed');
      renderCart(await response.json());
    } catch (error) { showToast('Cart could not be updated.'); controls.forEach((control) => { control.disabled = false; }); }
  };

   const addVariant = async (variantId, button) => {
    const label = button.textContent;
    button.disabled = true; button.textContent = 'Adding…';
    try {
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }) });
      if (!response.ok) throw new Error('Add request failed');
      await refreshCart(false);
    } catch (error) { showToast('This treat could not be added.'); button.disabled = false; button.textContent = label; }
  };

    const sellersData = {};
  const titleKey = (title) => String(title).toLowerCase()
    .replace(/\b\d+(\.\d+)?\s*(lbs?|oz|kg|g|pack|ct|count)\b/g, ' ')
    .replace(/[^a-z\s]/g, ' ').split(/\s+/).filter(Boolean).slice(0, 5).join(' ');

  const pickSellers = (cart, list) => {
    const seen = new Set(cart.items.map((item) => titleKey(item.product_title)));
    const out = [];
    for (const product of list) {
      if (cart.items.some((item) => item.product_id === product.id)) continue;
      if (!(product.variants || []).some((variant) => variant.available !== false)) continue;
      const key = titleKey(product.title);
      if (seen.has(key)) continue;
      seen.add(key); out.push(product);
      if (out.length >= 8) break;
    }
    return out;
  };

  const fetchSellers = async (cart) => {
    const cacheKey = BEST_SELLERS_COLLECTION || String(cart.items[0].product_id);
    if (sellersData[cacheKey]) return sellersData[cacheKey];
    const urls = BEST_SELLERS_COLLECTION
      ? [`${root}collections/${BEST_SELLERS_COLLECTION}/products.json?limit=24`]
      : [`${root}recommendations/products.json?product_id=${cart.items[0].product_id}&limit=10&intent=complementary`,
         `${root}recommendations/products.json?product_id=${cart.items[0].product_id}&limit=10&intent=related`];
    let list = [];
    for (const url of urls) {
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) continue;
      list = (await response.json()).products || [];
      if (pickSellers(cart, list).length >= 3) break;
    }
    sellersData[cacheKey] = list;
    return list;
  };

  const fillSellers = (box, products) => {
    const head = make('button', 'pf-cx-sellers-head'); head.type = 'button'; head.setAttribute('aria-expanded', 'true');
    head.append(make('span', '', 'Add these best sellers'), make('i', '', '▲'));
    const track = make('div', 'pf-cx-track');
    head.addEventListener('click', () => {
      const open = head.getAttribute('aria-expanded') === 'true';
      head.setAttribute('aria-expanded', String(!open)); track.hidden = open;
    });
    products.forEach((product) => {
      const variants = product.variants || [];
      const first = variants.find((variant) => variant.available !== false) || variants[0];
      const href = product.url || `${root}products/${product.handle}`;
      const imageSrc = (typeof product.featured_image === 'string' && product.featured_image) || product.featured_image?.url || product.images?.[0]?.src || product.images?.[0] || '';
      const card = make('article', 'pf-cx-card');
      const imageLink = make('a'); imageLink.href = href;
      if (imageSrc) { const image = make('img'); image.src = imageSrc; image.alt = ''; image.loading = 'lazy'; imageLink.append(image); }
      const name = make('b', '', product.title);
      const price = make('span', 'pf-cx-card-price', money(toCents(first?.price ?? product.price)));
      let action;
      if (variants.length > 1) { action = make('a', 'pf-cx-add', 'Choose'); action.href = href; }
      else { action = make('button', 'pf-cx-add', 'Add'); action.type = 'button'; action.addEventListener('click', () => addVariant(first.id, action)); }
      card.append(imageLink, name, price, action); track.append(card);
    });
    box.append(head, track); box.hidden = false;
  };

  const renderCart = (cart) => {
    cartRenderId += 1; const renderId = cartRenderId;
    document.querySelectorAll('[data-pf-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
    if (!cartContent) return;
    cartContent.replaceChildren();
    if (!cart.item_count) {
      const empty = make('div', 'pf-cart-empty');
      empty.append(make('small', '', 'Your cart is feeling peckish'), make('h3', '', 'Let’s fix that.'), make('p', '', 'Choose a whole-food favorite or build a custom bundle.'));
      const link = make('a', 'pf-pill pf-pill-orange', 'Shop treats →'); link.href = `${root}#shop`;
      empty.append(link); cartContent.append(empty); return;
    }

    /* Free-shipping progress */
    const remaining = Math.max(0, FREE_SHIP_MIN - cart.total_price);
    const progress = make('div', 'pf-cx-progress');
    progress.append(make('p', '', remaining ? `You’re ${money(remaining)} away from free shipping!` : 'Congrats! You get free standard shipping!'));
    const bar = make('div', 'pf-cx-bar'); const fill = make('span');
    fill.style.width = `${Math.min(100, Math.round((cart.total_price / FREE_SHIP_MIN) * 100))}%`;
    bar.append(fill); progress.append(bar);
    cartContent.append(progress, make('div', 'pf-cx-info', SHIPPING_INFO));

    /* Line items */
    const items = make('div', 'pf-cx-items');
    cart.items.forEach((item) => {
      const row = make('article', 'pf-cx-item');
      const imageLink = make('a', 'pf-cx-thumb'); imageLink.href = item.url;
      if (item.image) { const image = make('img'); image.src = item.image; image.alt = ''; imageLink.append(image); }

      const main = make('div', 'pf-cx-main');
      const head = make('div', 'pf-cx-head');
      const title = make('a', 'pf-cx-title', item.product_title); title.href = item.url;
      const priceBox = make('div', 'pf-cx-price');
      if (item.original_line_price > item.final_line_price) priceBox.append(make('s', '', money(item.original_line_price)));
      priceBox.append(make('span', '', money(item.final_line_price)));
      head.append(title, priceBox); main.append(head);

      const planName = item.selling_plan_allocation?.selling_plan?.name;
      if (item.variant_title && item.variant_title !== 'Default Title') main.append(make('small', 'pf-cx-meta', item.variant_title));
      if (planName) main.append(make('small', 'pf-cx-meta', planName));

      const foot = make('div', 'pf-cx-foot');
      const remove = make('button', 'pf-cx-remove', 'Remove'); remove.type = 'button';
      const qty = make('div', 'pf-cx-qty');
      const minus = make('button', '', '−'); minus.type = 'button'; minus.setAttribute('aria-label', 'Decrease quantity'); minus.disabled = item.quantity <= 1;
      const plus = make('button', '', '+'); plus.type = 'button'; plus.setAttribute('aria-label', 'Increase quantity');
      qty.append(minus, make('span', '', String(item.quantity)), plus);
      const controls = [remove, minus, plus];
      remove.addEventListener('click', () => changeLine(item.key, 0, controls));
      minus.addEventListener('click', () => changeLine(item.key, item.quantity - 1, controls));
      plus.addEventListener('click', () => changeLine(item.key, item.quantity + 1, controls));
      foot.append(remove, qty); main.append(foot);

      if (planName) {
        const plan = make('div', 'pf-cx-plan');
        plan.append(make('i', '', '✓'));
        const copy = make('span'); copy.append(make('b', '', 'Subscribe and Save'), make('small', '', planName));
        plan.append(copy); main.append(plan);
      }
      row.append(imageLink, main); items.append(row);
    });
    cartContent.append(items);

    /* Best sellers (loads after the cart is on screen) */
    const sellers = make('section', 'pf-cx-sellers'); sellers.hidden = true;
    cartContent.append(sellers);
    const sellersKey = BEST_SELLERS_COLLECTION || String(cart.items[0].product_id);
    const showSellers = (list) => {
      if (renderId !== cartRenderId) return;
      const products = pickSellers(cart, list);
      if (products.length) fillSellers(sellers, products);
    };
    if (sellersData[sellersKey]) showSellers(sellersData[sellersKey]);
    else fetchSellers(cart).then(showSellers).catch(() => {});

    /* Footer: subtotal + checkout */
    const footer = make('footer', 'pf-cx-footer');
    const points = make('p', 'pf-points-notice');
    if (cartContent.dataset.customerLoggedIn !== 'true') {
      const login = make('a', '', 'Log in'); login.href = root + 'account/login';
      points.append(login, document.createTextNode(' to earn '));
    } else points.append(document.createTextNode('Earn '));
        points.append(make('b', '', String(Math.floor(cart.total_price * POINTS_PER_DOLLAR / 100))), document.createTextNode(' points on this order!'), make('small', '', `Flock Club · ${POINTS_PER_DOLLAR} point${POINTS_PER_DOLLAR === 1 ? '' : 's'} per $1. Program opens soon.`));
    const total = make('div', 'pf-cx-total'); total.append(make('span', '', 'Subtotal'), make('strong', '', money(cart.total_price)));
    const checkout = make('a', 'pf-cx-checkout', 'Checkout →'); checkout.href = `${root}checkout`;
    footer.append(points, total, checkout, make('p', 'pf-cart-note', 'Taxes and shipping calculated at checkout'));
    cartContent.append(footer);
  };
  const refreshCart = async (shouldOpen = false) => {
    try {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart request failed');
      renderCart(await response.json());
      if (shouldOpen) openDrawer(cartDrawer);
    } catch (error) { showToast('Cart could not be loaded.'); }
  };

  document.querySelectorAll('[data-pf-quick-add]').forEach((form) => form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('button');
    if (button?.disabled) return;
    button.disabled = true;
    try {
      const response = await fetch(form.action, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Add request failed');
      showToast('Added to your cart.');
      await refreshCart(true);
    } catch (error) { showToast('This treat could not be added.'); }
    finally { button.disabled = false; }
  }));

  document.querySelectorAll('[data-pf-cart-open]').forEach((link) => link.addEventListener('click', (event) => { event.preventDefault(); refreshCart(true); }));
  document.querySelectorAll('[data-pf-search-open]').forEach((link) => link.addEventListener('click', (event) => { event.preventDefault(); openDrawer(searchDrawer); setTimeout(() => searchDrawer?.querySelector('input')?.focus(), 120); }));
  document.querySelectorAll('[data-pf-drawer-close]').forEach((button) => button.addEventListener('click', closeDrawers));
  overlay?.addEventListener('click', closeDrawers);

  const searchInput = document.querySelector('[data-pf-search-input]');
  const searchResults = document.querySelector('[data-pf-search-results]');
  let searchTimer;
  let searchController;
  const renderSearch = (products) => {
    if (!searchResults) return;
    searchResults.replaceChildren();
    if (!products.length) { searchResults.append(make('p', '', 'No treats found. Try another search.')); return; }
    products.forEach((product) => {
      const row = make('a', 'pf-search-result'); row.href = product.url;
      const image = make('img'); image.src = product.featured_image?.url || product.image || ''; image.alt = '';
      const copy = make('span'); copy.append(make('small', '', product.type || 'Whole-food treat'), make('b', '', product.title));
      const rawPrice = Number(product.price);
      const price = Number.isFinite(rawPrice) ? money(Math.round(rawPrice * 100)) : String(product.price || '');
      row.append(image, copy, make('strong', '', price));
      const variantId = product.variants?.[0]?.id;
      if (variantId && product.available !== false) {
        const add = make('button', '', 'Quick add'); add.type = 'button';
        add.addEventListener('click', async (event) => {
          event.preventDefault(); add.disabled = true;
          try {
            const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }) });
            if (!response.ok) throw new Error('Add request failed');
            showToast('Added to your cart.'); await refreshCart(true);
          } catch (error) { showToast('This treat could not be added.'); add.disabled = false; }
        });
        row.append(add);
      }
      searchResults.append(row);
    });
  };
  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimer); searchController?.abort();
    const query = searchInput.value.trim();
    if (!query) { searchResults.replaceChildren(make('p', '', 'Start typing to find a treat.')); return; }
    searchTimer = setTimeout(async () => {
      searchController = new AbortController();
      try {
        const url = `${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
        const response = await fetch(url, { signal: searchController.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Search request failed');
        const result = await response.json();
        renderSearch(result.resources?.results?.products || []);
      } catch (error) { if (error.name !== 'AbortError') searchResults.replaceChildren(make('p', '', 'Search is temporarily unavailable.')); }
    }, 180);
  });
  window.PetfuCart = { refresh: refreshCart, open: () => refreshCart(true) };

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('pf-in');
        observer.unobserve(entry.target);
      });
    }, { threshold: .08 });
    document.querySelectorAll('.pf-reveal,.pf-section-intro,.pf-product-card,.pf-story-copy,.pf-story-scene,.pf-bundle-head,.pf-bundle-summary,.pf-rewards-head,.pf-how,.pf-earn,.pf-reward-wallet').forEach((item) => {
      item.classList.add('pf-reveal'); observer.observe(item);
    });
  } else document.querySelectorAll('.pf-reveal').forEach((item) => item.classList.add('pf-in'));

  document.querySelectorAll('[data-pf-header]').forEach((header) => {
    const trigger = header.querySelector('[data-pf-mega-trigger]');
    const mega = header.querySelector('[data-pf-mega]');
    const sectionShell = header.closest('.shopify-section') || document;
    const panel = sectionShell.querySelector('[data-pf-mobile-panel]');
    const setMega = (open) => {
      trigger?.setAttribute('aria-expanded', String(open));
      mega?.setAttribute('aria-hidden', String(!open));
      mega?.classList.toggle('is-open', open);
    };
    trigger?.addEventListener('mouseenter', () => setMega(true));
    trigger?.addEventListener('focus', () => setMega(true));
    trigger?.addEventListener('click', () => setMega(true));
    mega?.addEventListener('mouseenter', () => setMega(true));
    header.addEventListener('mouseleave', () => setMega(false));
    const closeMobile = () => { panel?.classList.remove('is-open'); panel?.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('pf-shell-open'); };
    header.querySelector('[data-pf-mobile-open]')?.addEventListener('click', () => { panel?.classList.add('is-open'); panel?.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('pf-shell-open'); });
    sectionShell.querySelector('[data-pf-mobile-close]')?.addEventListener('click', closeMobile);
    panel?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMobile));
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      setMega(false);
      closeMobile();
      closeDrawers();
    });
  });

  document.querySelectorAll('[data-pf-bundle]').forEach((builder) => {
    const rows = [...builder.querySelectorAll('[data-pf-bundle-product]')].filter((row) => row.dataset.variantId);
    const quantities = new Map(rows.map((row) => [row.dataset.variantId, 0]));
    const status = builder.querySelector('[data-pf-status]');
    const add = builder.querySelector('[data-pf-add-bundle]');
    const minimum = Math.max(1, Number(builder.dataset.minItems) || 2);
    const maximum = Math.max(minimum, Number(builder.dataset.maxItems) || 8);
    const ready = builder.dataset.ready === 'true';
    const setText = (selector, value) => {
      const node = builder.querySelector(selector);
      if (node) node.textContent = value;
    };
    let busy = false;
    const state = () => {
      const count = [...quantities.values()].reduce((sum, quantity) => sum + quantity, 0);
      const subtotal = rows.reduce((sum, row) => sum + Number(row.dataset.price) * (quantities.get(row.dataset.variantId) || 0), 0);
      return { count, subtotal };
    };
    const render = () => {
      const { count, subtotal } = state();
      setText('[data-pf-count]', count);
      setText('[data-pf-summary-count]', count);
      setText('[data-pf-subtotal]', money(subtotal));
      setText('[data-pf-bundle-discount]', 'Any active offer is confirmed at checkout');
      setText('[data-pf-total]', money(subtotal));
      const remaining = Math.max(0, minimum - count);
      const message = remaining
        ? 'Choose ' + remaining + ' more item' + (remaining === 1 ? '' : 's') + ' to start your bundle'
        : count >= maximum
          ? 'Your ' + maximum + '-item combination is complete'
          : count + ' of ' + maximum + ' items selected';
      setText('[data-pf-unlock]', message);
      setText('[data-pf-progress-copy]', message);
      const progress = builder.querySelector('[data-pf-progress]');
      if (progress) { progress.max = maximum; progress.value = count; }
      builder.querySelectorAll('[data-pf-tier]').forEach((step) => step.classList.toggle('is-active', count >= Number(step.dataset.pfTier)));
      const chosen = rows.flatMap((row) => Array(quantities.get(row.dataset.variantId) || 0).fill(row));
      builder.querySelectorAll('[data-pf-slots] > span').forEach((slot, index) => {
        const row = chosen[index];
        slot.hidden = index >= maximum;
        slot.classList.toggle('is-filled', Boolean(row));
        slot.replaceChildren();
        if (row?.querySelector('img')) slot.append(row.querySelector('img').cloneNode(true));
        else slot.textContent = String(index + 1);
      });
      const selectedList = builder.querySelector('[data-pf-selected-list]');
      if (selectedList) {
        selectedList.replaceChildren();
        rows.forEach((row) => {
          const quantity = quantities.get(row.dataset.variantId) || 0;
          if (!quantity) return;
          const item = document.createElement('article');
          const sourceImage = row.querySelector('img');
          if (sourceImage) item.append(sourceImage.cloneNode(true));
          const copy = document.createElement('span');
          const name = document.createElement('b');
          name.textContent = row.dataset.title || 'Selected treat';
          const specification = document.createElement('small');
          specification.textContent = row.dataset.sku ? 'SKU ' + row.dataset.sku : 'Current selected specification';
          copy.append(name, specification);
          const countLabel = document.createElement('strong');
          countLabel.textContent = '× ' + quantity;
          item.append(copy, countLabel);
          selectedList.append(item);
        });
      }
      rows.forEach((row) => {
        const quantity = quantities.get(row.dataset.variantId) || 0;
        row.classList.toggle('is-selected', quantity > 0);
        const output = row.querySelector('output');
        const minus = row.querySelector('[data-pf-minus]');
        const plus = row.querySelector('[data-pf-plus]');
        if (output) output.textContent = quantity;
        if (minus) minus.disabled = busy || quantity === 0;
        if (plus) plus.disabled = busy || count >= maximum || row.dataset.available !== 'true';
      });
      if (add) add.disabled = busy || count < minimum || count > maximum || !ready;
    };
    rows.forEach((row) => {
      row.querySelector('[data-pf-plus]')?.addEventListener('click', () => {
        if (!busy && state().count < maximum && row.dataset.available === 'true') quantities.set(row.dataset.variantId, (quantities.get(row.dataset.variantId) || 0) + 1);
        render();
      });
      row.querySelector('[data-pf-minus]')?.addEventListener('click', () => {
        if (!busy) quantities.set(row.dataset.variantId, Math.max(0, (quantities.get(row.dataset.variantId) || 0) - 1));
        render();
      });
    });
    add?.addEventListener('click', async () => {
      const { count } = state();
      if (busy || count < minimum || count > maximum || !ready) return;
      busy = true;
      render();
      if (status) status.textContent = 'Adding your bundle…';
      const bundleId = 'petfu-' + Date.now();
      const items = [...quantities.entries()].filter(([, quantity]) => quantity).map(([id, quantity]) => ({ id: Number(id), quantity, properties: { '_petfu_bundle_id': bundleId } }));
      try {
        const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'The bundle could not be added.');
        const code = builder.dataset.bundleCode || '';
        if (code) { window.location.assign(root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart')); return; }
        if (status) status.textContent = 'Your bundle is in the cart.';
        showToast('Your bundle is in the cart.');
        await refreshCart(true);
      } catch (error) {
        if (status) status.textContent = error.message || 'This bundle could not be added. Please try again.';
      } finally {
        busy = false;
        render();
      }
    });
    render();
  });

  document.querySelectorAll('[data-pf-rewards]').forEach((wallet) => {
    let balance = Number(wallet.dataset.points || 0);
    let selected = null;
    let redeemedCount = 0;
    const status = wallet.querySelector('[data-pf-reward-status]');
    const overlay = wallet.querySelector('[data-pf-reward-overlay]');
    const modal = wallet.querySelector('[data-pf-reward-modal]');
    const availablePanel = wallet.querySelector('[data-pf-reward-panel="available"]');
    const redeemedPanel = wallet.querySelector('[data-pf-reward-panel="redeemed"]');
    const redeemedList = wallet.querySelector('[data-pf-redeemed-list]');
    const empty = wallet.querySelector('[data-pf-empty-rewards]');

    const switchTab = (name) => {
      wallet.querySelectorAll('[data-pf-reward-tab]').forEach((tab) => { const active = tab.dataset.pfRewardTab === name; tab.classList.toggle('is-active', active); tab.setAttribute('aria-selected', String(active)); });
      availablePanel.hidden = name !== 'available';
      redeemedPanel.hidden = name !== 'redeemed';
    };
    wallet.querySelectorAll('[data-pf-reward-tab]').forEach((tab) => tab.addEventListener('click', () => switchTab(tab.dataset.pfRewardTab)));

    const closeModal = () => { modal.hidden = true; overlay.hidden = true; };
    wallet.querySelectorAll('[data-pf-reward-close]').forEach((button) => button.addEventListener('click', closeModal));
    overlay?.addEventListener('click', closeModal);

    wallet.querySelectorAll('[data-pf-reward]').forEach((button) => button.addEventListener('click', () => {
      selected = { cost: Number(button.dataset.cost), value: Number(button.dataset.value) };
      wallet.querySelector('[data-pf-modal-points]').textContent = selected.cost;
      wallet.querySelector('[data-pf-modal-value]').textContent = selected.value;
      wallet.querySelector('[data-pf-modal-balance]').textContent = balance - selected.cost;
      modal.hidden = false; overlay.hidden = false;
    }));

    const addRedeemed = (code) => {
      redeemedCount += 1;
      wallet.querySelector('[data-pf-redeemed-count]').textContent = redeemedCount;
      empty.hidden = true;
      const item = document.createElement('article');
      const copy = document.createElement('button');
      const text = document.createElement('span');
      const title = document.createElement('b');
      const note = document.createElement('small');
      text.textContent = '✓'; title.textContent = `$${selected.value} off`; note.textContent = `${selected.cost} points used`;
      copy.type = 'button'; copy.textContent = `${code} · Copy code`;
      copy.addEventListener('click', async () => { await navigator.clipboard?.writeText(code); status.textContent = 'Reward code copied.'; });
      item.append(text, title, note, copy); redeemedList.prepend(item);
      switchTab('redeemed');
    };

    wallet.querySelector('[data-pf-confirm-reward]')?.addEventListener('click', async () => {
      if (!selected || selected.cost > balance || wallet.dataset.loyaltyEnabled !== 'true') return;
      const designMode = wallet.dataset.designMode === 'true';
      if (!wallet.dataset.customerId && !designMode) { window.location.href = `${root}account/login?return_url=/#rewards`; return; }
      status.textContent = 'Creating your secure reward…';
      try {
        let result;
        if (designMode && !wallet.dataset.customerId) result = { discountCode: `PETFU${selected.value}OFF-DEMO`, remainingPoints: balance - selected.cost };
        else {
          const response = await fetch(wallet.dataset.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ customerId: wallet.dataset.customerId, points: selected.cost, value: selected.value }) });
          if (!response.ok) throw new Error('Rewards endpoint unavailable');
          result = await response.json();
        }
        if (!result.discountCode) throw new Error('Missing discount code');
        balance = Number.isFinite(Number(result.remainingPoints)) ? Number(result.remainingPoints) : balance - selected.cost;
        wallet.querySelector('[data-pf-points]').textContent = balance;
        wallet.querySelectorAll('[data-pf-reward]').forEach((button) => {
          const cost = Number(button.dataset.cost); button.disabled = cost > balance;
          button.closest('article')?.classList.toggle('is-locked', cost > balance);
          button.textContent = cost > balance ? 'Need ' + (cost - balance) + ' more' : 'Redeem my points →';
        });
        addRedeemed(result.discountCode);
        status.textContent = 'Your reward is ready. Copy the code into checkout.';
        closeModal();
      } catch (error) { status.textContent = 'Connect the secure rewards app endpoint to enable redemption.'; closeModal(); }
    });
  });
})();

/* Client-preview referral form: no external message is sent. */
document.addEventListener('submit', (event) => {
  const form = event.target.closest?.('[data-pf-referral]');
  if (!form) return;
  event.preventDefault();
  const toast = document.querySelector('[data-pf-toast]');
  if (toast) {
    const message = toast.querySelector('b');
    if (message) message.textContent = 'Flock Club invitations will open soon. No invitation has been sent.';
    toast.classList.add('is-open');
    window.setTimeout(() => toast.classList.remove('is-open'), 3200);
  }
  form.reset();
});

/* Document-defined email offer. It is shown once per browser session and never
   blocks navigation after the shopper dismisses it. */
(() => {
  const overlay = document.querySelector('[data-pf-offer-overlay]');
  if (!overlay) return;
  const storageKey = 'petfu-offer-dismissed';
  const rememberDismissal = () => {
    try { window.sessionStorage.setItem(storageKey, 'true'); } catch (error) { /* privacy mode */ }
  };
  const close = () => {
    overlay.hidden = true;
    document.documentElement.classList.remove('pf-shell-open');
    rememberDismissal();
  };
  overlay.querySelectorAll('[data-pf-offer-close]').forEach((button) => button.addEventListener('click', close));
  overlay.addEventListener('click', (event) => { if (event.target === overlay) close(); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !overlay.hidden) close(); });
  let dismissed = false;
  try { dismissed = window.sessionStorage.getItem(storageKey) === 'true'; } catch (error) { /* privacy mode */ }
  const wait = Math.max(0, Number(overlay.dataset.pfOfferDelay || 7));
  if (!dismissed) window.setTimeout(() => {
    overlay.hidden = false;
    document.documentElement.classList.add('pf-shell-open');
  }, wait);
})();

/* PRD: keyboard-accessible treat finder and native Shopify selling plans. */
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const currency = window.Shopify?.currency?.active || 'USD';
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100);
  const overlay = document.querySelector('[data-pf-quiz-overlay]');
  if (overlay) {
    const form = overlay.querySelector('[data-pf-quiz]');
    const results = overlay.querySelector('[data-pf-quiz-result]');
    const matches = [...overlay.querySelectorAll('[data-pf-quiz-match]')];
    let opener;
    const close = () => { overlay.hidden = true; document.documentElement.classList.remove('pf-shell-open'); opener?.focus(); };
    document.querySelectorAll('[data-pf-quiz-open]').forEach((button) => button.addEventListener('click', () => {
      opener = button;
      const offer = document.querySelector('[data-pf-offer-overlay]'); if (offer) offer.hidden = true;
      document.querySelector('[data-pf-mobile-panel]')?.classList.remove('is-open');
      document.querySelector('[data-pf-mobile-panel]')?.setAttribute('aria-hidden', 'true');
      overlay.hidden = false; document.documentElement.classList.add('pf-shell-open');
      overlay.querySelector('[data-pf-quiz-close]').focus();
    }));
    overlay.querySelector('[data-pf-quiz-close]').addEventListener('click', close);
    overlay.addEventListener('click', (event) => { if (event.target === overlay) close(); });
    document.addEventListener('keydown', (event) => {
      if (overlay.hidden) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (event.key !== 'Tab') return;
      const focusable = [...overlay.querySelectorAll('button:not([disabled]),input:not([disabled]),a[href]')].filter((item) => item.getClientRects().length);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    form.addEventListener('submit', (event) => {
      event.preventDefault(); if (!form.reportValidity()) return;
      const answers = new FormData(form);
      const compatible = matches.filter((item) => item.dataset.species.split(' ').includes(answers.get('species')));
      const score = (item) => (item.dataset.goals.split(' ').includes(answers.get('goal')) ? 4 : 0) + (item.dataset.format === answers.get('format') ? 2 : 0);
      compatible.sort((a, b) => score(b) - score(a));
      matches.forEach((item) => { item.hidden = item !== compatible[0]; });
      form.hidden = true; results.hidden = false;
      results.querySelector('article:not([hidden]) a')?.focus();
    });
    overlay.querySelector('[data-pf-quiz-reset]').addEventListener('click', () => { form.reset(); results.hidden = true; form.hidden = false; form.querySelector('input')?.focus(); });
  }
  document.querySelectorAll('[data-pf-product-form]').forEach((form) => {
    const plan = form.querySelector('[data-pf-selling-plan]');
    const quantity = form.querySelector('[data-pf-purchase-quantity]');
    const notice = form.querySelector('[data-pf-order-points]');
    const update = () => {
      const selected = plan?.selectedOptions[0];
      const price = Number(selected?.dataset.price || notice?.dataset.price || 0);
      const count = Math.max(1, Number(quantity?.value) || 1);
      form.closest('.pf-product-details')?.querySelector('[data-pf-purchase-price]')?.replaceChildren(document.createTextNode(money(price)));
      const pointsValue = notice?.querySelector('[data-pf-order-points-value]');
      if (notice?.dataset.pfRewardsActive === 'true' && pointsValue) pointsValue.textContent = Math.floor(price * count / 100);
    };
    plan?.addEventListener('change', update); quantity?.addEventListener('input', update);
    form.querySelector('[data-pf-variant-select]')?.addEventListener('change', (event) => {
      const url = new URL(window.location.href); url.searchParams.set('variant', event.target.value); window.location.assign(url.toString());
    });
    update();
  });
})();

/* Accessible homepage image carousel. It pauses for direct interaction and
   respects system reduced-motion preferences. */
(() => {
  const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-pf-hero-carousel]').forEach((carousel) => {
    const slides = [...carousel.querySelectorAll('[data-pf-hero-slide]')];
    const dots = [...carousel.querySelectorAll('[data-pf-carousel-dot]')];
    if (slides.length < 2) return;
    let current = 0;
    let timer;
    const show = (next, focusDot = false) => {
      current = (next + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const active = index === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.querySelector('a')?.setAttribute('tabindex', active ? '0' : '-1');
      });
      dots.forEach((dot, index) => dot.setAttribute('aria-selected', String(index === current)));
      if (focusDot) dots[current]?.focus();
    };
    const stop = () => { window.clearInterval(timer); timer = undefined; };
    const start = () => {
      stop();
      const interval = Math.max(3000, Number(carousel.dataset.interval) || 6000);
      if (carousel.dataset.autoplay === 'true' && !reduceMotion) timer = window.setInterval(() => show(current + 1), interval);
    };
    carousel.querySelector('[data-pf-carousel-prev]')?.addEventListener('click', () => { show(current - 1); start(); });
    carousel.querySelector('[data-pf-carousel-next]')?.addEventListener('click', () => { show(current + 1); start(); });
    dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index, true); start(); }));
    carousel.addEventListener('pointerenter', stop);
    carousel.addEventListener('pointerleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', (event) => { if (!carousel.contains(event.relatedTarget)) start(); });
    document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); else start(); });
    show(0); start();
  });
})();

/* Final revision: editable About hover menu and distinct purchase modes. */
(() => {
  document.querySelectorAll('.pf-about-menu').forEach((menu) => {
    let closeTimer;
    const open = () => { window.clearTimeout(closeTimer); menu.open = true; };
    const close = () => { closeTimer = window.setTimeout(() => { if (!menu.matches(':focus-within')) menu.open = false; }, 120); };
    menu.addEventListener('mouseenter', open); menu.addEventListener('mouseleave', close);
    menu.querySelector('summary')?.addEventListener('focus', open);
  });
  document.querySelectorAll('[data-pf-plan-fieldset]').forEach((fieldset) => {
    const select = fieldset.querySelector('[data-pf-selling-plan]');
    const cards = [...fieldset.querySelectorAll('[data-pf-purchase-mode]')];
    const frequency = fieldset.querySelector('.pf-subscription-frequency');
    const setMode = (mode) => {
      const subscription = mode === 'subscribe';
      if (subscription) { const option = [...select.options].find((item) => item.value); if (!option) return; select.value = option.value; } else select.value = '';
      cards.forEach((card) => { const active = card.dataset.pfPurchaseMode === mode; card.classList.toggle('is-active', active); const input = card.querySelector('input[type="radio"]'); if (input) input.checked = active; });
      if (frequency) frequency.hidden = !subscription;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    };
    const subscribe = cards.find((card) => card.dataset.pfPurchaseMode === 'subscribe');
    if (![...select.options].some((item) => item.value)) { const input = subscribe?.querySelector('input'); if (input) input.disabled = true; subscribe?.classList.add('is-disabled'); subscribe?.setAttribute('aria-disabled', 'true'); }
    cards.forEach((card) => card.querySelector('input')?.addEventListener('change', (event) => { if (event.target.checked) setMode(card.dataset.pfPurchaseMode); }));
    setMode(select.value ? 'subscribe' : 'once');
  });
})();


/* Final document QA: keep desktop menus mutually exclusive and enable native collection filtering. */
(() => {
  document.querySelectorAll('[data-pf-header]').forEach((header) => {
    const shopTrigger = header.querySelector('[data-pf-mega-trigger]');
    const shopMega = header.querySelector('[data-pf-mega]');
    const aboutMenu = header.querySelector('.pf-about-menu');
    const closeShop = () => {
      shopTrigger?.setAttribute('aria-expanded', 'false');
      shopMega?.setAttribute('aria-hidden', 'true');
      shopMega?.classList.remove('is-open');
    };
    aboutMenu?.addEventListener('mouseenter', closeShop);
    aboutMenu?.querySelector('summary')?.addEventListener('focus', closeShop);
    shopTrigger?.addEventListener('mouseenter', () => { if (aboutMenu) aboutMenu.open = false; });
    shopTrigger?.addEventListener('focus', () => { if (aboutMenu) aboutMenu.open = false; });
  });

  document.querySelectorAll('[data-pf-collection]').forEach((collection) => {
    const buttons = [...collection.querySelectorAll('[data-pf-collection-filter]')];
    const items = [...collection.querySelectorAll('[data-pf-collection-item]')];
    const empty = collection.querySelector('[data-pf-collection-empty]');
    const apply = (button) => {
      const terms = (button.dataset.pfCollectionFilter || '').split(',').map((term) => term.trim()).filter(Boolean);
      let visible = 0;
      items.forEach((item) => {
        const haystack = item.dataset.search || '';
        const match = !terms.length || terms.some((term) => haystack.includes(term));
        item.hidden = !match;
        if (match) visible += 1;
      });
      buttons.forEach((candidate) => {
        const active = candidate === button;
        candidate.classList.toggle('is-active', active);
        candidate.setAttribute('aria-pressed', String(active));
      });
      if (empty) empty.hidden = visible > 0;
    };
    buttons.forEach((button) => button.addEventListener('click', () => apply(button)));
  });
})();


/* Product gallery thumbnails and review-media hydration. */
(() => {
  document.querySelectorAll('.pf-product-gallery').forEach((gallery) => {
    const main = gallery.querySelector('.pf-product-main-media img'); if (!main) return;
    gallery.querySelectorAll('[data-pf-gallery-thumb]').forEach((thumb) => thumb.addEventListener('click', () => { main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = thumb.dataset.image; main.alt = thumb.dataset.alt || main.alt; gallery.querySelectorAll('[data-pf-gallery-thumb]').forEach((item) => item.setAttribute('aria-pressed', String(item === thumb))); }));
  });
  const hydrateReviewImages = (root = document) => root.querySelectorAll?.('.jdgm-carousel-item__product-image[data-src]:not([src])').forEach((image) => { image.src = image.dataset.src; if (image.dataset.srcRetina) image.srcset = image.dataset.srcRetina + ' 2x'; });
  hydrateReviewImages(); const reviews = document.querySelector('.jdgm-carousel-wrapper'); if (reviews) new MutationObserver(() => hydrateReviewImages(reviews)).observe(reviews, { childList: true, subtree: true });
})();
